import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';

import styles from './FJHeadshotContinueButton.module.less';
import FJConstant from '../../../../constants/FJConstant';

const FJHeadshotContinueButton = ({
    selectedBackgroundPreference,
    selectedTheme,
    steps,
    onNext,
    currentStepIndex,
    onGenerate,
    taskStatus,
    unitPrice,
    totalOutput,
    isProjectLoading,
    imageUploadStatus,
}) => {
    const currentStep = useMemo(() => steps[currentStepIndex], [steps, currentStepIndex]);
    const isLastTwoStep = useMemo(() => currentStepIndex === steps.length - 2, [currentStepIndex, steps]);
    // 根据当前步骤获取选中的项目
    const selectedItems = useMemo(() => {
        if (currentStep.key === 'background') {
            return selectedBackgroundPreference || [];
        } else if (currentStep.key === 'theme') {
            return selectedTheme || [];
        }
        return [];
    }, [currentStep, selectedBackgroundPreference, selectedTheme]);

    const disabled = useMemo(() => {
        if (currentStep.key === 'theme') {
            return selectedItems.length < 3 || selectedItems.length > 10;
        }
        return false;
    }, [currentStep, selectedItems]);

    const canGenerate = useMemo(() => {
        return imageUploadStatus === FJConstant.SUCCESS;
    }, [imageUploadStatus]);

    return (
        <>
            {isLastTwoStep && (
                <div className={styles.button_box_step}>
                    <FJGenerateButton
                        className={styles.continue_button}
                        onClick={onGenerate}
                        isFree={false}
                        taskStatus={taskStatus}
                        useCredit={unitPrice * totalOutput}
                        isProjectLoading={isProjectLoading}
                        isShowUsageDetail={true}
                        disabled={!canGenerate}
                    />
                </div>
            )}
            {currentStepIndex < steps.length - 2 && (
                <div
                    className={classNames(currentStepIndex === 0 ? styles.button_box_category : styles.button_box_step)}
                >
                    <div className={styles.continue_button_container}>
                        <FJButton
                            text={FJLocalStore._('continue')}
                            type={FJButtonType.GRADIENT}
                            className={styles.continue_button}
                            onClick={onNext}
                            disabled={disabled}
                        />
                        {currentStep.multiple && selectedItems.length > 0 && (
                            <div className={styles.multiple_tag}>
                                <div className={styles.tag_number}>{selectedItems.length}</div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

FJHeadshotContinueButton.propTypes = {
    selectedBackgroundPreference: PropTypes.array,
    selectedTheme: PropTypes.array,
    onNext: PropTypes.func.isRequired,
    currentStepIndex: PropTypes.number,
    steps: PropTypes.array,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    unitPrice: PropTypes.number,
    totalOutput: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    imageUploadStatus: PropTypes.string,
};

export default FJHeadshotContinueButton;
